import Cookies from 'js-cookie'

export const cookies = {
  add<T>(key: string, value: T, options?: Cookies.CookieAttributes) {
    Cookies.set(key, JSON.stringify(value), options)

    return value
  },
  remove(key: string) {
    Cookies.remove(key)
  },
  get: <T>(key: string) => {
    const value = Cookies.get(key)
    return value ? JSON.parse(value) as T : undefined
  }
}